export { default as sortResults } from 'owa-service/lib/factory/sortResults';
export { default as propertyUri } from 'owa-service/lib/factory/propertyUri';
export { default as indexedPageView } from 'owa-service/lib/factory/indexedPageView';
export { default as personaResponseShape } from 'owa-service/lib/factory/personaResponseShape';
export { default as contextProperty } from 'owa-service/lib/factory/contextProperty';
export { default as findPeopleJsonRequest } from 'owa-service/lib/factory/findPeopleJsonRequest';
export { default as folderId } from 'owa-service/lib/factory/folderId';
export { default as targetFolderId } from 'owa-service/lib/factory/targetFolderId';
export { default as addressListId } from 'owa-service/lib/factory/addressListId';
export { default as distinguishedFolderId } from 'owa-service/lib/factory/distinguishedFolderId';
